import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['modal'];

    openModal(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        this.modal = new Modal(this.modalTarget);

        this.modal.toggle();

        if (window.innerWidth < 768 && document.querySelector('.modal-backdrop')) {
            document.querySelector('.modal-backdrop').remove();
        }
    }
}
